import { useUnsavedChanges } from "aic";
import { useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";

/**
 * The redirecting page
 */
export const RedirectingPage = (): React.ReactElement => {
  const { clearUnsavedChanges } = useUnsavedChanges("redirecting-page");
  useEffect(() => {
    clearUnsavedChanges();
  }, [clearUnsavedChanges]);

  return (
    <Container>
      <Row>
        <Col className="d-flex justify-content-center">
          <p style={{ paddingTop: "4rem" }}>Redirecting...</p>
        </Col>
      </Row>
    </Container>
  );
};

RedirectingPage.displayName = "RedirectingPage";

export default RedirectingPage;
